/**
 * Sections of the Settings window that can be shown or hidden via `setSettingsSectionsVisible`.
 *
 * A section renders only when it is visible here *and* its own runtime conditions hold (form
 * factor, Procore context, model type), so showing a section is never a guarantee that it
 * appears. Hiding one is presentation-only and leaves the preference it controls untouched.
 */
export const SETTINGS_SECTION_IDS = {
    MEASUREMENT_SYSTEM: "measurementSystem",
    PERFORMANCE: "performance",
    SELECTION_RESOLUTION: "selectionResolution",
    ENVIRONMENT: "environment",
    HOME_VIEW: "homeView",
    /** Mini map, navigation sphere and joysticks as one unit. */
    SHOW_IN_VIEWER: "showInViewer",
    /** SpaceMouse. */
    NAVIGATION: "navigation",
    MODEL_DOWNLOAD: "modelDownload",
} as const;

export type SettingsSectionId = (typeof SETTINGS_SECTION_IDS)[keyof typeof SETTINGS_SECTION_IDS];
